<div class="user-section">
  <div class="table-wrapper">
    <div class="table-header gap-4">
      <div class="align-items-center flex">
        <h2>Rule Engine Validation</h2>
         
      </div>

      <div class="align-items-center flex justify-content-end"> </div>
    </div>
      <div class="px-5 mt-5">
        <div class="sidebar-form">
          <div class="grid p-fluid">
            <div class="dropzone" fileDragDrop>
              <div class="text-wrapper">
                <div class="dropFile-wra">
                  <input
                    (change)="handleFileUpload($event)"
                    [(ngModel)]="uploadFile"
                    accept="text/csv"
                    id="file"
                    name="file"
                    type="file"
                    [disabled]="isLoading"
                  />
                  <div
                    class="flex flex-column align-items-center justify-content-center gap-4"
                  >
                    <img
                      alt="File upload"
                      src="../../assets/images/fileupload.svg"
                    />
                    <label class="textLink" for="file"
                    >Drag and drop file here or <u>Choose file</u></label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>